<template>
    <div v-if="bizAuth.viewHouse.hasRight" class="view-house-page">
        <view-house-comp :class="{'fixed': listIsFixed}"></view-house-comp>
    </div>
</template>
<script>
import viewHouseComp from '@/components/bussiness/mgtCategory/houseMgt/viewHouse/viewHouseComp.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            listIsFixed: false
        }
    },
    mounted () {
        // window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        // window.removeEventListener('scroll', this.handleScroll);
        // document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        'bizAuth.viewHouse.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('biz-add-house-head')[0].style.zIndex = '8'
            }else{
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('biz-add-house-head')[0].style.zIndex = '8'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
    },
    computed: {
        ...mapGetters({
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
    components: {
        viewHouseComp
    }
}
</script>
<style lang="scss" scoped>
    .view-house-page{
        position: relative;
        margin-top: 30px;
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/mgtCategory/houseMgt/viewHouse.vue